import * as types from "./types"

export function importBatches(file) {
  return {
    type: types.BATCHES_IMPORT,
    file
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/import.js